<template>
  <div id="app">
    <myheader></myheader>
    <div class="header-bj w-100 h-100 wow bounceInUp pc">
      <img class="w-100 h-100" :src="`http://www.waternaida.com/${banner}`" alt />
    </div>
    <div class="mb">
        <img class="w-100 mb" src="../../static/img/contact/mb_contact_banner.png" alt />
    </div>
    <div class="Breadcrumb">
      <el-breadcrumb class="Breadcrumb_item" separator-class="el-icon-arrow-right">
        <span>
          <i class="el-icon-minus"></i> Posición actual：
        </span>
        <el-breadcrumb-item :to="{ path: '/ESP' }">HOME</el-breadcrumb-item>
        <el-breadcrumb-item>CONTACTO</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main">
      <div id="all-map" class="map_mini" style="height:1000px;width:80%;margin:0 auto;"></div>
      <div class="contact_txt row">
        <div class="contacts col-lg-6">
          <span class="footer3_header w-75 d-block">Ningbo Naida Filter Tech Co.,Ltd.</span>
          <div class="mt-4 w-75 d-block">
            <img class="img1 mr-2" src="../img/contact/地址.png" alt />
            <span
              class
            >Dirección: No.28,Xingbin Road,Sino-Italy Ningbo Ecological Park,Yuyao,Zhejiang,China</span>
          </div>
          <div class="w-75 d-block">
            <img class="img2 mr-2" src="../img/contact/座机.png" alt />
            <span class>TEL: 0086 574 6209 6133</span>
          </div>
          <div class="w-75 d-block">
            <img class="img4 mr-2" src="../img/contact/传真.png" alt />
            <span class>FAX: 0086 574 62096121</span>
          </div>
          <div class="w-75 d-block">
            <img class="img3 mr-2" src="../img/contact/邮箱.png" alt />
            <span class>E-mail: <div>sales@waternaida.com</div><div>service@waternaida.com</div></span>
          </div>
        </div>
        <div class="contact_inpt col-lg-6 w-100">
          <div class="contact_inpt row">
            <el-input class="col-lg-6 mt-2" placeholder="Nombre" v-model="input_name" clearable></el-input>
            <el-input class="col-lg-6 mt-2" placeholder="Teléfono" v-model="input_phone" clearable></el-input>
            <el-input class="col-lg-12 mt-2" placeholder="E-mail" v-model="input_email" clearable></el-input>
            <el-input
              class="col-lg-12 mt-2"
              type="textarea"
              :rows="11"
              placeholder="Por favor ingrese el contenido"
              v-model="input_contact"
              clearable
            ></el-input>
            <div class="main_btn_txt col-lg-6 mt-2">
              <el-button class="w-100" @click="tijiao" type="primary">Enviar</el-button>
            </div>
            <div class="main_btn_txt col-lg-6 mt-2">
              <el-button class="w-100" @click="reset">Reiniciar</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <myfooter class="footer"></myfooter>
  </div>
</template>
<style scoped>
#app {
  width: 100%;
  margin: 0 auto;
}
.contact_inpt >>> .el-input__inner {
  background-color: #e5e5e5;
  border-radius: 0;
  box-shadow: inset 1px 1px 5px gray;
  border: 0;
}
.contact_inpt >>> .el-textarea__inner {
  background-color: #e5e5e5;
  border-radius: 0;
  box-shadow: inset 1px 1px 5px gray;
  border: 0;
}
.contact_inpt >>> .el-input {
  padding-left: 0;
}
.contact_inpt >>> .el-textarea {
  padding-left: 0;
}
.header-bj {
  margin-top: 40px;
}
.main_btn_txt {
  font-size: 24px;
  margin: 0;
  height: 50px;
  padding-left: 0;
}
.contact_inpt {
  width: 80%;
  margin: 0 auto;
  margin-top: -70px;
}
.contacts {
  color: white;
  text-align: left;
  line-height: 40px;
  margin-top: -70px;
}
.contacts > div {
  margin: 0 auto;
}
.contacts > div .img3{
    display: inline-block;
}
.contacts > div span div:nth-child(1){
    display: inline-block;
}
.contacts > div span div:last-child{
    margin-left: 5rem;
}
.contacts > div span div{
    line-height: normal;
}
.footer3_header {
  font-size: 24px;
  font-weight: bold;
  margin: 0 auto;
}
.contact_txt {
  background: url("../img/contact/map_bj.png");
  background-size: cover;
  z-index: 999;
  width: 80%;
  margin: 0 auto;
  position: absolute;
  top: 0;
  left: 10%;
  padding-top: 170px;
}
.main {
  position: relative;
  padding-top: 200px;
}
.Breadcrumb {
  /* background: lightblue; */
  display: block;
  width: 80%;
  margin: 0 auto;
  /* float: right; */
  margin-bottom: 100px;
}
.Breadcrumb_item > span {
  float: left;
  display: block;
}
.Breadcrumb_item {
  float: right;
  /* background-color: lightcoral; */
}
@media screen and (max-width: 1200px) {
  .header-bj {
    margin-top: 0px;
  }
}
@media screen and (max-width: 992px) {
  .contact_inpt {
    width: 80%;
    margin: 0 auto;
    margin-top: 1px !important;
  }
}
@media screen and (max-width: 762px) {
  .footer3_header {
    width: 90% !important;
    text-align: center;
  }
  .Breadcrumb {
    float: left;
  }
  .Breadcrumb_item {
    float: left;
  }
  .contacts > div {
    width: 100% !important;
    text-align: left;
    line-height: 25px;
  }
  .contact_inpt {
    width: 95%;
  }
  .contact_txt {
    padding-top: 100px;
    height: 900px;
    margin-top: -50px;
    width: 100%;
    left: 0;
  }
  .contacts {
    color: white;
    text-align: left;
    line-height: 40px;
    margin-top: 0px;
  }
  .contact_inpt {
    width: 80%;
    margin: 0 auto;
    margin-top: 0px;
  }
  .main > .map_mini {
    width: 100% !important;
  }
  .contacts {
    line-height: 30px;
    font-size: 14px;
  }
  .contacts:nth-child(2) {
    margin-top: 1% !important;
  }
  .contacts > span {
    margin-top: 2% !important;
    width: 100%!important;
    font-size: 20px;
  }
}
</style>
<script>
import myfooter from "./zzj/footer_ESP";
import myheader from "./zzj/header_ESP";
import WOW from "wowjs";
import AMap from "AMap";
export default {
  data() {
    return {
      input_name: "",
      input_phone: "",
      input_email: "",
      input_contact: "",
      banner: []
    };
  },
  methods: {
    GaodeMap() {
      var map = new AMap.Map("all-map", {
        center: [121.052654,30.256737], // [纬度，经度]
        resizeEnable: true,
        zoom: 13,
        lang: "en"
      });

      AMap.plugin(["AMap.ToolBar", "AMap.Scale"], function() {
        map.addControl(new AMap.ToolBar());

        map.addControl(new AMap.Scale());
      });
    },
    reset() {
      this.input_name = "";
      this.input_phone = "";
      this.input_email = "";
      this.input_contact = "";
    },
    tijiao() {
      let name = this.input_name;
      let phone = this.input_phone;
      let email = this.input_email;
      let contact = this.input_contact;
    //   let res_phone = /^1[345789]\d{9}$/;
        let res_phone = /^(?:\(?[0\+]?\d{1,3}\)?)[\s-]?/;
      let res_email = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (name == "" || phone == "" || email == "" || contact == "") {
        alert("¡Por favor, introduzca el formato correcto!");
      } else if (res_phone.test(this.input_phone) == false) {
        alert("¡Por favor, introduzca el número de teléfono correcto!");
      }else if(res_email.test(this.input_email) == false){
        alert("¡Por favor, introduzca el mensaje correcto!");
      } else {
        this.axios
          .post("/api/message/index", {
            name: this.input_name,
            phone: this.input_phone,
            email: this.input_email,
            content: this.input_contact,
            language: "1"
          })
          .then(res => {
            alert("成功！");
          })
          .catch(err => {
            console.log(err);
          });
        this.reset();
      }
    }
  },
  components: {
    myfooter: myfooter,
    myheader: myheader
  },
  created() {
    this.axios
      .get("/api/banner/index?categoryID=20&language=1")
      .then(res => {
        this.banner = res.data.imgList[0].image;
        console.log(this.banner);
      })
      .catch(err => {
        console.log(err);
      });
  },
  mounted() {
    let wow = new WOW.WOW({
      boxClass: "wow",
      animateClass: "animated",
      mobile: true,
      live: true
    });
    wow.init();
    this.GaodeMap();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/contact_ESP.vue